import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-hometiles',
  templateUrl: './hometiles.component.html'
})
export class HomeTilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
